import script from "./ProfileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileComponent.vue?vue&type=style&index=0&id=19fe52d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fe52d5"]])

export default __exports__